// Axios instance for Vue CLI build (uses VUE_APP_API_BASE)
import axios from 'axios'

// const baseURL = process.env.VUE_APP_API_BASE || 'https://odos-register-api-uat.depa.or.th/api'
const baseURL = process.env.VUE_APP_API_BASE

const api = axios.create({
  baseURL,
  withCredentials: true
})

function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

api.interceptors.request.use((config) => {
  const csrf = getCookie('csrfToken')
  if (csrf) config.headers['x-csrf-token'] = csrf
  return config
})

export default api
